<template>
  <div class="menu-box-wrap">
    <div class="menu-box" v-if="usrMenu.length > 0">
      <b-nav pills v-for="item in usrMenu" class="menu-wrap">
        <b-nav-item-dropdown id="my-nav-dropdown" :text="lang(item.NavMnName)" toggle-class="nav-link-custom" class="menu-wrap__item">
          <b-dropdown-item
            v-for="submenu in usrMenuSubMenu.filter(data => data.NavMnName === item.NavMnName && data.NavSmID !== 'NASM202500001621')"
            :href="submenu.NavSmLink"
            :key="submenu.NavSmName"
          >
            {{ lang(submenu.NavSmName) }}
          </b-dropdown-item>
        </b-nav-item-dropdown>
      </b-nav>
    </div>

    <div class="mobilemenu-box-wrap" v-if="screen === true && usrMenu.length > 0">
      <span class="mobile-menu-icon" @click="showHideMenu" v-if="screen === true && usrMenu.length > 0">
        <i class="fa fa-bars fa-2x" aria-hidden="true"></i>
      </span>

      <div class="gn-menu-wrapper gn-open-all">
        <div class="gn-scroller">
          <el-menu class="el-menu-vertical-demo" unique-opened="unique-opened">
            <el-submenu v-for="item in usrMenu" :key="item.NavMnName" :index="item.NavMnName">
              <template slot="title">{{ lang(item.NavMnName) }}</template>
              <el-menu-item
                v-for="submenu in usrMenuSubMenu.filter(data => data.NavMnName === item.NavMnName)"
                :index="submenu.NavMnName"
                @click="showHideMenu"
              >
                <router-link :to="submenu.NavSmLink">
                  {{ lang(submenu.NavSmName) }}
                </router-link>
              </el-menu-item>
            </el-submenu>
          </el-menu>
        </div>
        <!-- /gn-scroller -->
      </div>

      <!--            <el-menu default-active="2" class="el-menu-vertical-demo ">-->
      <!--                <el-submenu>-->
      <!--                    <template slot="title">-->
      <!--                        <i class="material-icons">-->
      <!--                            dashboard-->
      <!--                        </i>-->
      <!--                        <span>Navigation</span>-->
      <!--                    </template>-->
      <!--                    <el-submenu v-for="item in usrMenu" :index="item.NavMnName">-->
      <!--                        <template slot="title">{{lang(item.NavMnName)}}</template>-->
      <!--                        <el-menu-item v-for="submenu in usrMenuSubMenu.filter(data => data.NavMnName === item.NavMnName)"-->
      <!--                                      :index="submenu.NavMnName">-->
      <!--                            <router-link :to="submenu.NavSmLink">-->
      <!--                                {{lang(submenu.NavSmName)}}-->
      <!--                            </router-link>-->
      <!--                        </el-menu-item>-->
      <!--                    </el-submenu>-->
      <!--                </el-submenu>-->
      <!--            </el-menu>-->
    </div>
  </div>
</template>

<script>
import DataSource from '../data/datasource'
import { lang } from '../locale/index'
import Cookies from 'js-cookie'
import configAdmin from '@/config/configAdmin'
import { checkIsMiddleton, getStaffPortalStatus } from '@/helper/util_custom'
import { showMedicineMenu } from '../helper/util_custom'
import { MEDICINE_MENUS } from '../constants/medicine-menu'

export default {
  name: 'sideMenu',
  data() {
    return {
      pathName: null,
      primaryMenu: [],
      nonPrimaryTable: [],
      primaryMenuFiltered: [],
      active: false,
      currentMenu: null,
      currentParentMenuId: null,
      currentParentMenuId2: null,
      isNullItem: '',
      showMobileMenu: false,
      mouseover: false,
      scrollPosition: null,
      isMobile: false,
      screen: '',
      usrMenuSubMenu: [],
      usrMenu: [],
      schoolID: '',
      teacherID: '',
    }
  },
  created() {
    window.addEventListener('resize', this.checkMobile)
    // this.handleResize();
  },
  destroy() {
    window.removeEventListener('scroll', this.updateScroll)
    window.removeEventListener('resize', this.checkMobile)
  },
  async mounted() {
    window.addEventListener('scroll', this.updateScroll)
    this.checkMobile()

    // MIS ROLE
    this.schoolID = Cookies.get('schoolSession')
    this.teacherID = Cookies.get('userIDSession')
    if (getStaffPortalStatus) {
      if (
        Cookies.get('authToken') !== null &&
        Cookies.get('authToken') !== undefined &&
        Cookies.get('authToken') !== '' &&
        Cookies.get('authToken') !== 'undefined'
      ) {
        this.getUserMenu()
      }
    }
  },
  methods: {
    lang,
    updateScroll() {
      this.scrollPosition = window.scrollY
    },
    didClickAway: function (e) {
      this.event = function (event) {
        if (event.target !== e.target) {
          this.currentParentMenuId = null
          document.body.removeEventListener('click', this.event)
        } else {
          this.currentParentMenuId = menuId
        }
      }.bind(this)
      document.body.addEventListener('click', this.event)
    },
    handleParentMenuClick(menuId) {
      // if clicked menu already open, then make it close
      if (this.currentParentMenuId === menuId) {
        this.currentParentMenuId = null
      }
      // open clicked menu
      else {
        this.currentParentMenuId = menuId
      }
    },
    checkMobile() {
      let screenWidth = window.innerWidth
      if (screenWidth <= 769) {
        this.screen = true
      } else {
        this.screen = false
      }
    },
    async getUserMenu() {
      let extendDate = new Date(new Date().getTime() + 120 * 60 * 1000)
      let expireDate = new Date(new Date().getTime() + 180 * 60 * 1000)
      Cookies.set('subMenuItem', '', { expires: expireDate })

      const response = await DataSource.shared.getUserMenu()
      if (response) {
        if (response.code === '88') {
          window.location.replace('/')
        } else if (response.code === '99') {
          console.log('getUserMenu Error')
        } else if (response.code === '2') {
          console.log('getUserMenu No Record')
        } else {
          // this.usrMenuSubMenu = response.Table;
          this.usrMenuSubMenu = []
          this.usrMenu = []

          //remove duplicated link
          response.Table.forEach(m => {
            let checkExistingLink = this.usrMenuSubMenu.filter(item => item.NavSmLink === m.NavSmLink)
            //isSpecifyMenu = hide mis menu
            let isSpecifyMenu = configAdmin.misMenu.find(d => d === m.NavSmLink)
            //isNonMISMenu = hide non mis menu
            let isNonMISMenu = configAdmin.nonMisMenu.find(d => d === m.NavSmLink)

            if (checkIsMiddleton()) {
              if (checkExistingLink.length < 1 && !isNonMISMenu) {
                this.usrMenuSubMenu.push(m)
              }
            } else if (checkIsMiddleton()) {
              if (checkExistingLink.length < 1 && !isNonMISMenu && !isSpecifyMenu) {
                this.usrMenuSubMenu.push(m)
              }
            } else {
              if (checkExistingLink.length < 1 && !isSpecifyMenu) {
                this.usrMenuSubMenu.push(m)
              }
            }

            if (m.NavSmLink === 'CreateBroadcast') {
              Cookies.set('subMenuItem', m.NavSmLink, { expires: expireDate })
            }
          })
          //remove duplicated link

          //check if user can access this page
          let routePathFullPath = this.$route.fullPath
          let routePath = this.$route.path

          if (routePath !== '/' && !this.$route.path.toLowerCase().startsWith('/public/')) {
            var checkIfUserCanAccessThisPage = this.usrMenuSubMenu.filter(function (checkIfUserCanAccessThisPageItem) {
              if (checkIfUserCanAccessThisPageItem.NavSmLink.toLowerCase() === routePath.toLowerCase()) return checkIfUserCanAccessThisPageItem
            })

            if (
              checkIfUserCanAccessThisPage.length < 1 &&
              !routePathFullPath.includes('admin=admin') &&
              !window.location.host.toUpperCase().includes('LOCALHOST')
            ) {
              // window.location.replace('/');
              this.$router.push({
                path: '/',
              })
            }
          }
          //check if user can access this page

          response.Table.forEach(m => {
            if (m.NavSmNavMnID !== 'No') {
              var checkExistingUsrMenu = this.usrMenu.filter(function (checkExistingUsrMenuItem) {
                if (checkExistingUsrMenuItem.NavMnName === m.NavMnName) return checkExistingUsrMenuItem
              })

              if (checkExistingUsrMenu.length < 1) {
                let newRow = {
                  NavMnName: m.NavMnName,
                }

                this.usrMenu.push(newRow)
              }
            }
          })

          // Remove medicine menus for certain school(s)
          if (!showMedicineMenu()) {
            this.usrMenuSubMenu = this.usrMenuSubMenu.filter(m => !MEDICINE_MENUS.includes(m.NavSmName))
          }
        }
      }
    },

    showHideMenu() {
      if ($('.gn-menu-wrapper').css('display') === 'block') {
        $('.gn-menu-wrapper').hide()
        $('.mobile-notif-icon').show()
      } else {
        $('.mobile-notif-icon').hide()
        $('.gn-menu-wrapper').show()
      }
    },
    onSlotClick() {
      this.$router.push({
        name: 'Academica',
        params: { url: 'https://academica.etonhouse.com/headless/Calendars/PTC/' + this.schoolID + '/' + this.teacherID },
      })
      // window.open('https://academica.etonhouse.com/headless/Calendars/PTC/' + this.schoolID + '/' + this.teacherID, '_blank');
    },
  },
}
</script>
<style scoped>
.fixed-header {
  position: fixed;
  top: 0;
  width: 100%;
  z-index: 99;
}

.gn-menu-wrapper {
  display: none;
  position: absolute;
  z-index: 999;
  background: inherit;
  width: 100%;
  height: 100%;
}

.mobile-menu-icon {
  display: block;
  position: absolute;
  top: 20px;
  left: 5px;
  color: white;
  cursor: pointer;
}
</style>
<style></style>
